/* eslint-disable */
import React from 'react';
import compose from 'lodash/fp/compose';
import {
  withTranslation,
  withCustomRouter,
  withUserPreferences,
} from 'components/hoc';
import MyDataContentTemplate from 'components/Dashboard/MyData/common/MyDataContentTemplate';
import LottieLoader from 'components/common/LottieLoader';
import { withWorkExperienceInfo } from 'components/hoc/WorkExperienceInfo';
import { getFullName } from "components/utils";

const WorkExperience = (props) => {
  // Add filterableColumns configuration
  const filterableColumns = [
    {
      columnId: 'person_id',
      columnDataType: 'text',
    },
    {
      columnId: 'organisation',
      columnDataType: 'text',
    },
    {
      columnId: 'valid_from',
      columnDataType: 'date',
    },
    {
      columnId: 'valid_to',
      columnDataType: 'date',
    },
    {
      columnId: 'title_description',
      columnDataType: 'text',
    },
    {
      columnId: 'profession',
      columnDataType: 'text',
    },
    {
      columnId: 'industry',
      columnDataType: 'text',
    },
  ];

  const truncate = (name) => name && name.length > 25 ? `${name.substring(0, 25)}...` : name;

  const mapFields = () => {
    const { workExperienceInfo, trObj, fd } = props;
    console.log('workExperienceInfo', workExperienceInfo);
    return workExperienceInfo.data.map((data) => {
      return {
        ...data,
        id: data.id,
        valid_from: fd(data?.valid_from),
        valid_to: fd(data?.valid_to),
        person: getFullName(data?.person_detail),
        profession: truncate(trObj(data?.profession_detail)),
        organisation: truncate(data?.organisation_detail?.name),
        industry: truncate(trObj(data?.organisation_detail?.industry_type_detail)),
      };
    });
  };

  const { loaded, deleteBulkWorkExperienceInfo, gotoCreatePath } = props;

  if (!loaded) {
    return (
      <>
        <LottieLoader />
      </>
    );
  }

  return (
    <MyDataContentTemplate
      tableName="work_experience"
      columns={[]}
      data={mapFields()}
      handleCreateForm={gotoCreatePath}
      bulkDelete={deleteBulkWorkExperienceInfo}
      filterableColumns={filterableColumns}
    />
  );
};

export default compose(
  withTranslation,
  withWorkExperienceInfo,
  withCustomRouter,
  withUserPreferences,
)(WorkExperience);
